import { Grid, Box, Typography, Button, Chip } from "@mui/material";
import React from "react";
import classes from "../Styles/project.module.css";
const Project = ({
  name,
  index,
  description,
  icon,
  link,
  image,
  lang,
  type,
}) => {
  const typeLabel = type === "website" ? "Website" : "Web App";
  return (
    <>
      <Grid item md={4} xs={12} sx={{ pl: 1, pr: 1 }}>
        <Typography sx={{ pl: 2, pb: 2, pt: 2 }}>
          <span className={classes.proj_title}>Project {index} </span>
          <span className={classes.proj_name}>
            {" "}
            {`//`} {name}
          </span>
        </Typography>
        <Box className={classes.proj}>
          <Box
            sx={{
              backgroundImage: `url(${image})`,
              backgroundPosition: "center",
              backgroundRepeat: "no-repeat",
              backgroundSize: "cover",
              height: "200px",
              borderTopLeftRadius: "15px",
              borderTopRightRadius: "15px",
              width: "100%",
            }}
          />
          <Box px={2} pt={2}>
            <Chip
              label={typeLabel}
              size="small"
              variant="outlined"
              sx={{
                color: "#607B96",
                borderColor: "#1E2D3D",
                fontFamily: "'Fira Code', monospace !important",
              }}
            />
          </Box>
          <Typography
            sx={{
              color: "#607B96",
              fontSize: "16px",
              p: 2,
              wordBreak: "break-word",
              fontFamily: "'Fira Code', monospace !important",
            }}
          >
            {description}
          </Typography>
          <a style={{ textDecoration: "none" }} href={`${link}`} target="blank">
            <Button
              size="large"
              sx={{
                color: "white",
                fontSize: "12px",
                backgroundColor: "#1C2B3A",
                fontFamily: "'Fira Code', monospace !important",
                ml: 2,
              }}
            >
              view-project
            </Button>
          </a>
          <Box display="flex" gap={2} flexWrap="wrap" py={4} px={2}>
            {lang.map((item) => {
              const colors = [
                "primary",
                "secondary",
                "error",
                "warning",
                "info",
                "success",
              ];
              const randomColor =
                colors[Math.floor(Math.random() * colors.length)];
              return (
                <Chip
                  key={item}
                  label={item}
                  variant="filled"
                  color={randomColor}
                />
              );
            })}
          </Box>
          <Box className={classes.proj_icon}>{icon}</Box>
        </Box>
      </Grid>
    </>
  );
};

export default Project;
